var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablerIconBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5556 25.5556V26.6667C16.5556 27.5507 16.9067 28.3986 17.5319 29.0237C18.157 29.6488 19.0048 30 19.8889 30C20.7729 30 21.6208 29.6488 22.2459 29.0237C22.871 28.3986 23.2222 27.5507 23.2222 26.6667V25.5556M17.6667 12.2222C17.6667 11.6329 17.9008 11.0676 18.3175 10.6509C18.7343 10.2341 19.2995 10 19.8889 10C20.4783 10 21.0435 10.2341 21.4602 10.6509C21.877 11.0676 22.1111 11.6329 22.1111 12.2222C23.3871 12.8256 24.4749 13.7648 25.2578 14.9392C26.0408 16.1136 26.4894 17.479 26.5556 18.8889V22.2222C26.6392 22.913 26.8838 23.5745 27.2698 24.1535C27.6558 24.7324 28.1723 25.2127 28.7778 25.5556H11C11.6055 25.2127 12.122 24.7324 12.508 24.1535C12.894 23.5745 13.1386 22.913 13.2222 22.2222V18.8889C13.2884 17.479 13.737 16.1136 14.5199 14.9392C15.3029 13.7648 16.3907 12.8256 17.6667 12.2222Z",
    stroke: "#97999B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconBell);
export default __webpack_public_path__ + "static/media/tabler-icon-bell.c9eed018f37c81be817e97c9649dcf6c.svg";
export { ForwardRef as ReactComponent };